import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { renderModel } from '../../util/renderModel';
import { chatActions } from '../reducers/chat';
import { selectStartingNodeId } from '../selectors/chat';
import { selectDealerOfferParams, selectReferral } from '../selectors/meta';

const isCopilot = renderModel.isCopilot();

export const useStartChatListener = () => {
  const dispatch = useDispatch();
  const chatStartingNodeId = useSelector(selectStartingNodeId);
  const dealerOfferParams = useSelector(selectDealerOfferParams);
  const referral = useSelector(selectReferral);

  useEffect(() => {
    // nodeId can be empty string(to start chat from root node)
    if (chatStartingNodeId !== undefined) {
      dispatch(
        chatActions.setStartChatParameters({
          nodeId: chatStartingNodeId,
          shouldStartNewChat: 'true',
          ...(isCopilot && { referral }),
        }),
      );
    }
  }, [chatStartingNodeId, dispatch]);

  useEffect(() => {
    if (dealerOfferParams) {
      dispatch(
        chatActions.setStartChatParameters({
          ...Object.fromEntries(dealerOfferParams),
          ...(isCopilot && { referral }),
        }),
      );
    }
  }, [dealerOfferParams, dispatch]);
};
